// src/SiteNav.jsx
import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import BuyButton from "./buybutton";

export default function SiteNav() {
  const [open, setOpen] = useState(false);
  const [acc, setAcc]   = useState({ shop: true, explore: false }); // accordions
  const location = useLocation();

  // Close menu on route/hash change
  useEffect(() => { setOpen(false); }, [location.pathname, location.hash]);

  // Lock scroll when menu is open
  useEffect(() => {
    const html = document.documentElement;
    const body = document.body;
    if (open) { html.style.overflow = "hidden"; body.style.overflow = "hidden"; }
    else      { html.style.overflow = "";       body.style.overflow = ""; }
    return () => { html.style.overflow = ""; body.style.overflow = ""; };
  }, [open]);

  // Close on Escape
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && setOpen(false);
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  const toggle = (k) => setAcc(s => ({ ...s, [k]: !s[k] }));

  const linksDesktop = (
    <>
      <BuyButton
        product={{ name: "Dope Shot", price: 36, image: "/dopeshoot-model3.webp" }}
        className="buy-btn-nav"
        packSize={1}
      >
        BUY NOW
      </BuyButton>

      <Link to="/science">SCIENCE</Link>
      {/*<Link to="/about">OUR STORY</Link>*/}
      <Link to="/faq">FAQs</Link>
      <Link to="/contact">CONTACT US</Link>
    </>
  );

  return (
    <>
      <header className="nav">
        <div className="brand-wrap">
          <Link to="/"><img className="brand-mark" src="/StickerDopeShot.webp" alt="Dope Shot logo" /></Link>
        </div>

        {/* Desktop links */}
        <nav className="links" aria-label="Primary">{linksDesktop}</nav>

        {/* Burger (mobile) */}
        <button
          className="burger"
          aria-expanded={open}
          aria-controls="mobile-nav"
          aria-label={open ? "Close menu" : "Open menu"}
          onClick={() => setOpen(o => !o)}
        >
          <span />
        </button>
      </header>

      {/* MOBILE DRAWER */}
      <aside
        id="mobile-nav"
        className={`sheetnav ${open ? "is-open" : ""}`}
        aria-hidden={!open}
        role="dialog"
        aria-modal="true"
      >
        {/* scrim */}
        <button className="sheetnav-scrim" aria-label="Close menu" onClick={() => setOpen(false)} />

        {/* sheet */}
        <div className="sheetnav-panel">
          <div className="sheetnav-header">
            <button className="sheetnav-close" aria-label="Close" onClick={() => setOpen(false)}>✕</button>
          </div>

          <ul className="sheetnav-list" role="list">
            
             {/* Home (single row link) */}
            <li className="acc">
              <Link to="/" onClick={() => setOpen(false)} className="acc-head as-link">
                <span>HOME</span>
               {/* <i className="acc-arrow" aria-hidden="true">›</i>*/}
               <i className="acc-plus" aria-hidden="true" />
              </Link>
            </li>

            {/* SHOP (accordion w/ Buy button) */}
            <li className={`acc ${acc.shop ? "open" : ""}`}>
              <button className="acc-head" onClick={() => toggle("shop")}>
                <span>SHOP</span><i className="acc-plus" aria-hidden="true" />
              </button>
              <div className="acc-body">
                <BuyButton
                  product={{ name: "Dope Shot", price: 36, image: "/dopeshoot-model3.webp" }}
                  className="buy-btn-sheet"
                  packSize={1}
                >
                  BUY NOW
                </BuyButton>
              </div>
            </li>

            {/* EXPLORE (accordion) */}
            <li className={`acc ${acc.explore ? "open" : ""}`}>
              <button className="acc-head" onClick={() => toggle("explore")}>
                <span>EXPLORE</span><i className="acc-plus" aria-hidden="true" />
              </button>
              <div className="acc-body">
                <Link to="/faq" onClick={() => setOpen(false)} className="acc-link">FAQs</Link>
                <Link to="/contact" onClick={() => setOpen(false)} className="acc-link">Contact Us</Link>
              </div>
            </li>

            {/* THE STORY (single row link) 
            <li className="acc">
              <Link to="/about" onClick={() => setOpen(false)} className="acc-head as-link">
                <span>THE STORY</span>
               {/* <i className="acc-arrow" aria-hidden="true">›</i>*
               <i className="acc-plus" aria-hidden="true" />
              </Link>
            </li>*/}

             {/* THE SCIENCE (single row link) */}
            <li className="acc">
              <Link to="/science" onClick={() => setOpen(false)} className="acc-head as-link">
                <span>SCIENCE</span>
               {/* <i className="acc-arrow" aria-hidden="true">›</i>*/}
               <i className="acc-plus" aria-hidden="true" />
              </Link>
            </li>
          </ul>

        { /* <div className="sheetnav-footer">
            <Link to="/login" onClick={() => setOpen(false)} className="login-row">
              <span className="login-ico" aria-hidden>👤</span> Log In
            </Link>

            <div className="social-row">
              <a href="https://facebook.com" target="_blank" rel="noreferrer" aria-label="Facebook" className="social-ico"></a>
              <a href="https://instagram.com" target="_blank" rel="noreferrer" aria-label="Instagram" className="social-ico"></a>
            </div>
          </div>*/}
        </div>
      </aside>
    </>
  );
}
